module.exports = function() {
  return new Worker(__webpack_public_path__ + "147baa786cdb7c9e6c1e.worker.js");
};